/*
  JS Specific for the Cholesterol Basics page and any other page with a body class of "cholesterol" (as of right now, it is only the basics page)
 */

cholesterol = {
  // an object that is only called on the cholesterol pages
  init: function initialize(){
    this.cE();
    this.eL();
    if(document.body.style.MozTransform !== undefined || !self.ActiveXObject && 'ActiveXObject' in self){
      // THIS IS FIREFOX  or IE
      // Firefox doesn't support percentages with svg and `transform-origin`. If you are reading this, please check it's status with Firefox, because the animations work there, but they work wrong due to each elements origin. The svgs are resized, so finding px positions is a pain
    } else {
      // fire webanimations, but not on Firefox
      this.wA();
    }
  },
  cE: function cacheElements(){
    /*
     * If page is less than or equal to 600px AND supports touchevents, then cache it's state via cholesterol.VPM
     */
    cholesterol.VPM = false; // viewport mobile
    if(gliv.returnWindowWidth() <= 600 && Modernizr.touchevents){
      cholesterol.VPM = true;
    }

    /*
     * CHOLESTEROL BASICS SVG ELEMENTS
     */
    cholesterol.sourcesSvg = {};
    cholesterol.sourcesSvg.el = document.querySelector('svg#sources');
    cholesterol.sourcesSvg.shine = cholesterol.sourcesSvg.el.querySelector('#shine');

    cholesterol.cholesterolSvg = {};
    cholesterol.cholesterolSvg.el = document.querySelector('svg.cholesterol');
    cholesterol.cholesterolSvg.ray = cholesterol.cholesterolSvg.el.querySelector('.ray');
    cholesterol.cholesterolSvg.c = cholesterol.cholesterolSvg.el.querySelector('.big-c');
    cholesterol.cholesterolSvg.cLetter = cholesterol.cholesterolSvg.c.querySelector(".letter");
    cholesterol.cholesterolSvg.cShadow = cholesterol.cholesterolSvg.c.querySelector(".shadow");

    cholesterol.importantSvg = {};
    cholesterol.importantSvg.el = document.querySelector('svg.important');
    cholesterol.importantSvg.ray1 = cholesterol.importantSvg.el.querySelector('.hormones .ray');
    cholesterol.importantSvg.ray2 = cholesterol.importantSvg.el.querySelector('.vitamin-d .ray');

    cholesterol.transpartSvg = {};
    cholesterol.transpartSvg.el = document.querySelector('svg.transport');
    cholesterol.transpartSvg.arrow = cholesterol.transpartSvg.el.querySelector('.arrow');
    cholesterol.transpartSvg.bubble1 = cholesterol.transpartSvg.el.querySelector('.bubble-1');
    cholesterol.transpartSvg.bubble2 = cholesterol.transpartSvg.el.querySelector('.bubble-2');
    cholesterol.transpartSvg.bubble3 = cholesterol.transpartSvg.el.querySelector('.bubble-3');
    cholesterol.transpartSvg.bubble4 = cholesterol.transpartSvg.el.querySelector('.bubble-4');

  },
    eL: function(){
      $.each($('.jump-link'), function(){
          $(this).on('click', function(e){
              e.preventDefault();
              let jumpTo = $(this).data('id');
              $('html, body').animate({
                  scrollTop: $('#'+jumpTo).offset().top - 20
              }, 1000);
          });
      });

    },

  wA: function webAnimations(){
    cholesterol.sourcesSvg.shineAnimation = cholesterol.sourcesSvg.shine.animate([
        { transform: "rotate(0deg) scale(0.95)" },
        { transform: "rotate(360deg) scale(0.90)" }
      ], {
        direction: 'alternate',
        duration: 10000,
        iterations: Infinity
    });
    cholesterol.cholesterolSvg.rayAnimation = cholesterol.cholesterolSvg.ray.animate([
        { transform: "rotate(0deg) scale(1)" },
        { transform: "rotate(180deg) scale(0.8)" },
        { transform: "rotate(360deg) scale(1)" }
      ], {
        direction: 'alternate',
        duration: 10000,
        iterations: Infinity
    });

    cholesterol.cholesterolSvg.cLetterAnimation = cholesterol.cholesterolSvg.cLetter.animate([
        { transform: "translate(0px,0px)" },
        { transform: "translate(-2px,2px)" }
      ], {
        direction: 'alternate',
        duration: 5000,
        iterations: Infinity
    });
    cholesterol.cholesterolSvg.cShadowAnimation = cholesterol.cholesterolSvg.cShadow.animate([
        { transform: "translate(0px,0px)" },
        { transform: "translate(2px,-2px)" }
      ], {
        direction: 'alternate',
        duration: 5000,
        iterations: Infinity
    });

    cholesterol.importantSvg.ray1Animation = cholesterol.importantSvg.ray1.animate([
        { transform: "scale(1)" },
        { transform: "scale(0.5)" }
      ], {
        direction: 'alternate',
        duration: 1000,
        iterations: Infinity
    });
    cholesterol.importantSvg.ray2Animation = cholesterol.importantSvg.ray2.animate([
        { transform: "scale(1)" },
        { transform: "scale(0.5)" }
      ], {
        direction: 'alternate',
        duration: 1000,
        iterations: Infinity,
        delay: 1000
    });
    cholesterol.transpartSvg.bub1Animation = cholesterol.transpartSvg.bubble1.animate([
        {transform: "translate(0,0) scale(1)"},
        {transform: "translate(-1px,1px) scale(0.95)"},
        {transform: "translate(1px,-2px) scale(1.05)"}
      ], {
        direction: 'alternate',
        duration: 500,
        iterations: Infinity
    });
    cholesterol.transpartSvg.bub2Animation = cholesterol.transpartSvg.bubble2.animate([
        {transform: "translate(0,0) scale(1)"},
        {transform: "translate(1px,-1px) scale(1.05)"},
        {transform: "translate(-1px,2px) scale(0.95)"}
      ], {
        direction: 'alternate',
        duration: 500,
        iterations: Infinity,
        delay: 250
    });
    cholesterol.transpartSvg.bub3Animation = cholesterol.transpartSvg.bubble3.animate([
        {transform: "translate(0,0) scale(1)"},
        {transform: "translate(-1px,1px) scale(0.95)"},
        {transform: "translate(1px,-2px) scale(1.05)"}
      ], {
        direction: 'alternate',
        duration: 500,
        iterations: Infinity,
        delay:333
    });
    cholesterol.transpartSvg.bub4Animation = cholesterol.transpartSvg.bubble4.animate([
        {transform: "translate(0,0) scale(1)"},
        {transform: "translate(1px,-1px) scale(1.05)"},
        {transform: "translate(-2px,1px) scale(0.95)"}
      ], {
        direction: 'alternate',
        duration: 500,
        iterations: Infinity,
        delay:100
    });

  },

} // end cholesterol
